// ── TrainingCTA.jsx ───────────────────────────────────────────────────────────
// FIXES:
//  - CTA actions stack properly on mobile via tp-cta-actions-row responsive CSS
//  - Enroll halo uses will-change: box-shadow
//  - Removed duplicate inline styles now handled in tokens
import { DiscordIcon, ChevronRight, Eyebrow } from "./TrainingShared";

export const CTA_CSS = `
  .tp-cta {
    padding: 9rem 1.5rem;
    position: relative;
    overflow: hidden;
    text-align: center;
    contain: layout style;
  }
  .tp-cta::before {
    content: '';
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 68% 68% at 50% 50%, rgba(77,127,255,.075), transparent 70%),
      radial-gradient(ellipse 38% 38% at 18% 80%, rgba(130,72,245,.055), transparent 60%);
    pointer-events: none;
  }
  .tp-cta::after {
    content: '';
    position: absolute; inset: 0;
    background-image:
      radial-gradient(1.5px 1.5px at 20% 30%, rgba(255,255,255,.38) 0%, transparent 100%),
      radial-gradient(1.5px 1.5px at 80% 10%, rgba(255,255,255,.28) 0%, transparent 100%),
      radial-gradient(1px 1px at 50% 80%,    rgba(255,255,255,.18) 0%, transparent 100%),
      radial-gradient(1px 1px at 10% 60%,    rgba(255,255,255,.28) 0%, transparent 100%),
      radial-gradient(1.5px 1.5px at 90% 70%,rgba(255,255,255,.18) 0%, transparent 100%);
    pointer-events: none;
  }
  .tp-cta-inner {
    position: relative;
    max-width: 700px;
    margin: 0 auto;
    z-index: 1;
  }

  .tp-cta-enroll-block {
    position: relative;
    display: inline-block;
    margin-bottom: .625rem;
  }
  .tp-cta-enroll-halo {
    position: absolute;
    inset: -10px;
    border-radius: 24px;
    background: radial-gradient(ellipse 100% 100% at 50% 50%, rgba(77,127,255,.14), transparent 70%);
    animation: tp-enroll-breathe 3s ease-in-out infinite;
    pointer-events: none;
    will-change: box-shadow;
  }

  .tp-cta-actions {
    display: flex;
    flex-direction: column;
    gap: .75rem;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 2.5rem;
  }
  .tp-cta-actions-row {
    display: flex;
    gap: .875rem;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .tp-cta-or {
    font-size: .68rem;
    color: var(--tp-t3);
    letter-spacing: .12em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: .5rem;
  }
  .tp-cta-or::before, .tp-cta-or::after {
    content: '';
    width: 28px; height: 1px;
    background: var(--tp-line2);
  }

  .tp-cta-perks {
    display: flex; flex-wrap: wrap;
    gap: .875rem; justify-content: center;
  }
  .tp-cta-perk {
    display: flex; align-items: center; gap: 6px;
    font-size: .8rem; color: var(--tp-t3); font-weight: 600;
  }
  .tp-cta-perk-dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: var(--tp-green);
    box-shadow: 0 0 6px var(--tp-green);
  }
  .tp-pk-crown {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: .45rem 1rem;
    background: linear-gradient(135deg, rgba(245,158,11,.1), rgba(251,191,36,.07));
    border: 1px solid rgba(245,158,11,.22);
    border-radius: 100px;
    font-size: .68rem; font-weight: 700;
    color: var(--tp-gold);
    text-transform: uppercase; letter-spacing: .09em;
    margin-bottom: 1rem;
  }

  .tp-cta-urgency {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: .4rem 1rem;
    background: rgba(240,68,68,.065);
    border: 1px solid rgba(240,68,68,.18);
    border-radius: 100px;
    font-size: .7rem;
    font-weight: 700;
    color: #fca5a5;
    letter-spacing: .06em;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }
  .tp-cta-urgency-dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #f04444;
    box-shadow: 0 0 6px #f04444;
    animation: tp-pulse-dot 1.4s ease-in-out infinite;
  }

  @media (max-width: 640px) {
    .tp-cta { padding: 5rem 1rem; }
    .tp-cta-enroll-block { width: 100%; }
    .tp-cta-enroll-block .tp-btn-primary { width: 100%; justify-content: center; }
    .tp-cta-actions-row { flex-direction: column; width: 100%; }
    .tp-cta-actions-row .tp-btn-discord { width: 100%; justify-content: center; }
    .tp-cta-perks { gap: .5rem; }
  }
`;

export default function TrainingCTA({ scrollToPayment }) {
  return (
    <section className="tp-cta">
      <div className="tp-cta-inner">
        <Eyebrow center>Limited Seats</Eyebrow>

        <div className="tp-cta-urgency">
          <span className="tp-cta-urgency-dot" />
          Cohort filling fast — seats are limited
        </div>

        <h2 className="tp-section-h2" style={{ marginBottom: "1.25rem" }}>
          Ready to Build
          <br />
          <em>Something Real?</em>
        </h2>
        <p className="tp-section-sub" style={{ margin: "0 auto 2.5rem" }}>
          Cohorts are kept small on purpose. Enroll today and secure your spot
          before it fills — then join 10,000+ devs on Discord.
        </p>

        <div className="tp-cta-actions">
          <div className="tp-cta-enroll-block">
            <div className="tp-cta-enroll-halo" aria-hidden="true" />
            <button
              className="tp-btn-primary"
              onClick={scrollToPayment}
              style={{ fontSize: "1.05rem", padding: "1.1rem 3rem" }}
            >
              Enroll Now — ₨2,000
              <ChevronRight size={16} />
            </button>
          </div>

          <div className="tp-cta-or">or</div>

          <a
            href="https://discord.gg/qCvxh7ZhSv"
            target="_blank"
            rel="noopener noreferrer"
            className="tp-btn-discord"
          >
            <DiscordIcon size={16} />
            Join Discord Free
          </a>
        </div>

        <div className="tp-cta-perks">
          {[
            "Real projects",
            "Free internship",
            "Official certificate",
            "₨2,000 only",
            "10K+ community",
            "Pakistan's #1 Discord",
          ].map((p) => (
            <span key={p} className="tp-cta-perk">
              <span className="tp-cta-perk-dot" />
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
